__turbopack_context__.v({
  "packages": "booking-presentation-module__yFLNkG__packages",
  "page": "booking-presentation-module__yFLNkG__page",
  "section": "booking-presentation-module__yFLNkG__section",
  "theme": "booking-presentation-module__yFLNkG__theme",
  "webPage": "booking-presentation-module__yFLNkG__webPage",
});
